require("./threepl-train-voucher-containers-table.scss");

import {ChangeDetectionStrategy, Component, input, output} from "@angular/core";
import {TrainContainerDetails} from "../../../models/train-container-details.model";
import {HazardousMaterial, TrainCar, UnNumberOption} from "../../models/train-provider-settings.model";

export interface ContainerChange {
  container: TrainContainerDetails;
  index: number;
}

export interface SharedCarChange {
  carId: string;
  isSharedCar: boolean;
}

@Component({
  selector: "app-threepl-train-voucher-containers-table",
  templateUrl: "./threepl-train-voucher-containers-table.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplTrainVoucherContainersTableComponent {
  readonly containers = input.required<TrainContainerDetails[]>();
  readonly cars = input<TrainCar[]>([]);
  readonly sharedCarsMap = input<Record<string, boolean>>({});
  readonly hazardousMaterials = input<HazardousMaterial[]>([]);
  readonly unNumbers = input<UnNumberOption[]>([]);
  readonly isEdit = input(false);
  readonly submitted = input(false);

  readonly changeContainer = output<ContainerChange>();
  readonly isSharedCarChange = output<SharedCarChange>();
  readonly removeContainer = output<ContainerChange>();
}
